import { render } from "./Preference.vue?vue&type=template&id=3acbf996&scoped=true"
import script from "./Preference.vue?vue&type=script&lang=js"
export * from "./Preference.vue?vue&type=script&lang=js"

import "./Preference.vue?vue&type=style&index=0&id=3acbf996&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3acbf996"

export default script